import React, {useState, Fragment, useRef} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {shiftFilterTitleInterface} from "../../../interfaces/shiftFilterTitleInterface";
import {useOutsideClick} from "../../../misc/helperHooks";

const SelectionGridFiltersTitleDropdown = (props) => {

  const {filterTitle, allTitles, scrollToTitle} = props;
  const [dropdownOpened, setDropdownOpened] = useState(false);
  const dropdownElement = useRef(null);

  // console.log("allTitles", allTitles);

  useOutsideClick(dropdownElement, () => {
    setDropdownOpened(false);
  });

  const handleButtonClick = (fTitle) => {
    setDropdownOpened(false);
    scrollToTitle(fTitle);
  }

  const dropDownHeight = allTitles.length * 34;
  const styles = {
    height: dropdownOpened ? dropDownHeight + "px" : 0
  };

  return (
    <Fragment>
      <span className="ui-scroll-title__text ui-scroll-title__text--with-dropdown"
            onClick={() => setDropdownOpened(!dropdownOpened)} ref={dropdownElement}>
        {filterTitle.filterValue.displayText}
      </span>
      <div className="ui-select__dropdown" style={styles}>
        <ul className="ui-select__dropdown-list">
          {allTitles.map((fTitle, fTitleIndex) => {
            return (
              <li key={"title" + fTitleIndex}
                  onClick={() => handleButtonClick(fTitle)}
                  className={"ui-select__dropdown-list-item"}>
                <span className={"ui-checkbox__label"}>
                  {fTitle.filterValue.displayText}
                </span>
              </li>
            )
          })}
        </ul>
      </div>
    </Fragment>
  )
}

SelectionGridFiltersTitleDropdown.propTypes = {
  filterTitle: PropTypes.shape(shiftFilterTitleInterface).isRequired,
  allTitles: PropTypes.array.isRequired,
  scrollToTitle: PropTypes.func.isRequired
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionGridFiltersTitleDropdown)
